/* PRINT SHEET — every truck's permanent tracker QR on one page, ready to stick in the
   cabs (or hand to the pump crews). Tokens are minted on the way in. */
import { useEffect, useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Printer, Loader2 } from "lucide-react";
import { PreviewLinkWarning } from "@/components/PreviewLinkWarning";

export default function TruckQrSheet() {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const trucks = (await api.get("/trucks")).data || [];
        const out = [];
        for (const t of trucks) {
          const { data } = await api.post(`/trucks/${t.id}/track-token`, { reset: false });
          out.push({ ...t, url: `${window.location.origin}/truck/${data.track_token}` });
        }
        setRows(out);
      } catch (e) { toast.error(e.response?.data?.detail || "Could not build the sheet"); setRows([]); }
    })();
  }, []);

  return (
    <div className="p-6 print:p-0" data-testid="truck-qr-sheet">
      <style>{`@media print { .no-print { display:none !important } body { background:#fff } }`}</style>
      <div className="no-print flex items-end justify-between gap-3 flex-wrap mb-4">
        <div>
          <div className="mono text-[10px] uppercase tracking-[0.3em] text-primary-orange">Fleet</div>
          <h1 className="heading text-3xl font-black uppercase">Truck tracker <span className="text-primary-orange">QR sheet</span></h1>
          <p className="mono text-sm text-muted-industrial mt-1">One permanent QR per truck. Print it, cut them up, one in each cab and one for the pump crew.</p>
        </div>
        <button type="button" onClick={() => window.print()} data-testid="truck-qr-sheet-print"
          className="mono uppercase tracking-widest font-black bg-primary-orange text-black px-6 py-3 inline-flex items-center gap-2"><Printer className="w-4 h-4" /> Print sheet</button>
      </div>
      <div className="no-print mb-4"><PreviewLinkWarning what="sheet of QR codes" /></div>

      {!rows && <div className="mono text-sm text-muted-industrial inline-flex items-center gap-2"><Loader2 className="w-4 h-4 animate-spin" /> Building the sheet…</div>}

      <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
        {(rows || []).map((t) => (
          <div key={t.id} className="border-2 border-black bg-white text-black p-3 text-center break-inside-avoid" data-testid={`truck-qr-card-${t.number}`}>
            <div className="heading text-2xl font-black leading-none">{t.number}</div>
            <div className="mono text-[10px] text-zinc-500 mb-2">{t.rego || "\u00a0"}</div>
            <QRCodeSVG value={t.url} size={170} level="M" includeMargin={false} className="mx-auto" />
            <div className="mono text-[7px] text-zinc-500 break-all mt-2">{t.url}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
